<template>
  <div class="flex flex-col space-y-4">
    <div class="flex justify-between">
      <div class="tabs flex space-x-8 border-b mb-4">
        <button
          @click="currentTab = 'ListCompanies'"
          class="px-4 py-2 font-semibold border-b-4"
          :class="{'border-custom-yellow text-custom-blue': currentTab === 'ListCompanies', 'text-gray-500': currentTab !== 'ListCompanies'}"
        >
          FFS Companies
        </button>
        <button
          @click="currentTab = 'ListCoveredPatients'"
          class="px-4 py-2 font-semibold border-b-4"
          :class="{'border-custom-yellow text-custom-blue': currentTab === 'ListCoveredPatients', 'text-gray-500': currentTab !== 'ListCoveredPatients'}"
        >
          Covered Patients
        </button>
      </div>
      <div class="flex items-center">
        <CustomButton
          label="New Company"
          :icon-path="'M5 12h14m-7 7V5'"
          bg-class="bg-custom-yellow"
          @click="openCompanyModal"
        />
      </div>
    </div>

    <FFSCompaniesList v-if="currentTab === 'ListCompanies'" :refresh="refresh" />
    <FFSCoveredPatientsList v-if="currentTab === 'ListCoveredPatients'" :refresh="refresh" />

    <CreateCompanyModal :show="showNewCompanyModal" @close="closeCompanyModal" @created="refetch"/>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import CustomButton from "@/components/CustomButton.vue"
import FFSCompaniesList from "@/views/pages/ffs-management/FFSCompaniesList.vue"
import FFSCoveredPatientsList from "@/views/pages/ffs-management/FFSCoveredPatientsList.vue"
import CreateCompanyModal from "@/views/modals/ffs-management/CreateCompanyModal.vue"

const currentTab = ref("ListCompanies")
const refresh = ref(false)
const showNewCompanyModal = ref(false)

const openCompanyModal = () => {
  showNewCompanyModal.value = true;
}

const closeCompanyModal = () => {
  showNewCompanyModal.value = false;
}

const refetch = () => {
  refresh.value = !refresh.value
}
</script>

